var Component = require("!../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../node_modules/vue-loader/lib/selector?type=script&index=0!./App.vue"),
  /* template */
  require("!!../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-20e85dee\",\"hasScoped\":false}!../node_modules/vue-loader/lib/selector?type=template&index=0!./App.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/App.vue
// module id = 316
// module chunks = 1